/* ═══════════════════════════════════════════
   CAPRICE GLAM — Theme JS
   ═══════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {

  /* ─── FAQ Accordion ─── */
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.faq-item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* ─── Product tabs ─── */
  document.querySelectorAll('.tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = this.dataset.tab;
      var parent = this.closest('.product-tabs');
      if (!parent) return;
      parent.querySelectorAll('.tab-btn').forEach(function(b) { b.classList.remove('active'); });
      parent.querySelectorAll('.tab-panel').forEach(function(p) { p.style.display = 'none'; });
      this.classList.add('active');
      var panel = parent.querySelector('[data-panel="' + target + '"]');
      if (panel) panel.style.display = 'block';
    });
  });

  /* ─── Quantity selectors ─── */
  document.querySelectorAll('.qty-selector').forEach(function(sel) {
    var input = sel.querySelector('input[name="quantity"]') || sel.querySelector('.qty-value');
    sel.querySelector('.qty-minus').addEventListener('click', function() {
      var val = parseInt(input.value || input.textContent) - 1;
      if (val < 1) val = 1;
      if (input.value !== undefined) input.value = val; else input.textContent = val;
    });
    sel.querySelector('.qty-plus').addEventListener('click', function() {
      var val = parseInt(input.value || input.textContent) + 1;
      if (input.value !== undefined) input.value = val; else input.textContent = val;
    });
  });

  /* ─── Mobile menu ─── */
  var menuToggle = document.querySelector('.mobile-menu-toggle');
  var headerNav = document.querySelector('.header-nav');
  if (menuToggle && headerNav) {
    menuToggle.addEventListener('click', function() {
      headerNav.classList.toggle('open');
    });
  }

  /* ─── Product gallery thumbs ─── */
  document.querySelectorAll('.product-gallery__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var gallery = this.closest('.product-gallery');
      gallery.querySelectorAll('.product-gallery__thumb').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
      var mainImg = gallery.querySelector('.product-gallery__main img');
      if (mainImg && this.querySelector('img')) {
        mainImg.src = this.querySelector('img').src;
      }
    });
  });

  /* ─── Cart drawer ─── */
  var cartToggle = document.querySelector('[data-cart-toggle]');
  var cartDrawer = document.querySelector('.cart-drawer');
  var cartOverlay = document.querySelector('.cart-drawer-overlay');
  var cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

});
